<div class="select-container mr-16" [ngClass]="customStyle" appClickOutside (clickOutside)="hideList()" [isActive]="isListShown">
  <div class="select-input-wrapper input-wrapper" (click)="handleTriggerClick($event)">
    <input class="select-input has-prefix"
      type="text"
      [placeholder]="placeholder"
      [formControl]="displayValue"
      (blur)="handleInputBlur()"
      (change)="handleInputChange()"
      (keyup)="handleInputChange($event)"
      (keypress)="preventEnterKeyBehaviour($event)"
      (keydown)="setHighlightedOption($event)"
      [ngClass]="{'input-error': displayValue.errors}"
      (keypress)="checkInput($event)"
      (paste)="validateInput($event)"
      autocomplete="off"
      [attr.disabled]="riderLimitReached ? true : null"
      (mouseenter)="riderLimitReached ?isListShown=true : null"
      (mouseleave)="riderLimitReached ?isListShown=false : null "
    />
    <img src="assets/images/search.svg" class="input-icon prefix"/>
  </div>
  <ul class="select-list" *ngIf="isListShown ">
    <li class="select-option ellipsis"
      *ngFor="let option of selectOptions; let optionIndex = index"
      (click)="onOptionClick(option)"
      [ngClass]="{'active-item': optionIndex == activeOption}"
    >
      {{getOptionLabel(option)}}
    </li>
    <li class="no-results" *ngIf=" !configObject && !selectOptions.length && !riderLimitReached">Person not found. </li>
    <li class="no-results" *ngIf=" configObject && !selectOptions.length && !riderLimitReached">Person not found. Click below button to add.</li>
    <li class="no-results" *ngIf="riderLimitReached">Your company policy prohibits adding more passengers.</li>
    <li *ngIf="configObject && configObject.key=='AddRiderRow' && configObject.visibility" class="displayFlex add-guest" (click)="addRider()"
    [ngClass]="{'disabled':riderLimitReached}"
    > <img src="assets/bulk.svg" alt="" class="mr-4" style="width: 16px;"> <span class="fs-12 font-weight-700 text-primary">  {{ configObject.displayName}}</span> </li>
  </ul>
  <div class="error-msg" *ngIf="displayValue.errors && displayValue.errors.secure">{{errorMessages.pattern}}</div>
</div>

    <!-- <mat-form-field class="search-form-field" appearance="outline">
      <mat-icon matPrefix svgIcon="search" *ngIf="isTyped"></mat-icon>
      <input matInput id="pac-input" placeholder="Search" name="searchTerm" [(ngModel)]="searchTerm"
        (input)="checkTyping($event)">
      <mat-icon matSuffix svgIcon="close-grey" *ngIf="!isTyped" (click)="resetSearchInput()"></mat-icon>
    </mat-form-field> -->